import { useEffect } from "react";
import diceDeskHeader from "@/assets/dice-1920s-desk-header.webp";

let warmed = false;

/**
 * Warms the lazy Dice route and its header artwork while the visitor is still on
 * the homepage. Without this, the browser can only ask for the desk photo once
 * the route chunk has arrived and rendered, so the background visibly loads in.
 */
export function prefetchDicePage() {
  if (warmed) return;
  warmed = true;

  const link = document.createElement("link");
  link.setAttribute("rel", "prefetch");
  link.setAttribute("as", "image");
  link.href = diceDeskHeader;
  document.head.appendChild(link);

}

let chunkWarmed = false;

/**
 * Warms the Dice route code. Called on hover/focus of the Dice Roller link only:
 * parsing the chunk at idle competed with homepage interactions (the Create menu).
 */
export function prefetchDiceChunk() {
  if (chunkWarmed) return;
  chunkWarmed = true;
  import("@/pages/Dice").catch(() => {});
}

/** Schedules prefetchDicePage() once the browser is idle, cleaning up on unmount. */
export function usePrefetchDicePage() {
  useEffect(() => {
    const idleWindow = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout?: number }) => number;
      cancelIdleCallback?: (id: number) => void;
    };

    const handle = idleWindow.requestIdleCallback
      ? idleWindow.requestIdleCallback(prefetchDicePage, { timeout: 4000 })
      : window.setTimeout(prefetchDicePage, 2000);

    return () => {
      if (idleWindow.cancelIdleCallback) idleWindow.cancelIdleCallback(handle);
      else window.clearTimeout(handle);
    };
  }, []);
}
